import { Injectable } from '@angular/core';
import { AirspaceBoundariesComponent } from '../footer/airspace-boundaries/airspace-boundaries.component';
import { AirSpaceBoundaryModel } from '../models/air-space-boundary';
import { AirspaceBoundariesControlService } from './airspace-boundaries-control.service';
import { PointsService } from './points.service';
import { ToolsControlService } from './tools-control.service';

@Injectable({
  providedIn: 'root'
})
export class AirSpaceBoundaryFilterService {

  active : boolean = false;
  fullScreenMode : boolean = false;
  public loading : boolean = false;

  airSpaceBoundariesOnMap: AirSpaceBoundaryModel[] = [];

  constructor(private toolsService : ToolsControlService,
        private airspaceController : AirspaceBoundariesControlService,
        private pointsService : PointsService
         ) {

     }

  openWindow():void {
    this.active = true;
    this.toolsService.navigationOnTop = true;
    this.getAirSpaceBoundariesFromDatabase();
  }

  getAirSpaceBoundariesFromDatabase() : void {
    this.loading = true;
    this.pointsService.getAirSpaceBoundaries().subscribe((results) => {
      this.airspaceController.airspaceBoundaires = results;
      this.loading = false;
    });
  }

}
